import loraWanImage from 'images/lora-wan.png';
import nbIotImage from 'images/nb-iot.png';
import otherImage from 'images/other.png';
import { IntlShape } from 'react-intl';
import { InstallationTechnologyButtonConfig as messages } from 'routes/installation/messages';
import { InstallationTechnology } from '../installationTechnology';

interface InstallationTechnologyButtonConfig {
  image: string;
  imageWidth: number;
  name: string;
  serialName: {
    lowerCase: string;
    titleCase: string;
  };
}

export const getInstallationTechnologyButtonConfig = (
  intl: IntlShape,
  installationTechnology: InstallationTechnology,
): InstallationTechnologyButtonConfig => {
  const configs: Record<InstallationTechnology, InstallationTechnologyButtonConfig> = {
    [InstallationTechnology.LoraWan]: {
      image: loraWanImage,
      imageWidth: 150,
      name: 'LoRaWAN',
      serialName: {
        lowerCase: 'devEUI',
        titleCase: 'DevEUI',
      },
    },
    [InstallationTechnology.NBIoT]: {
      image: nbIotImage,
      imageWidth: 150,
      name: 'NB-IoT',
      serialName: {
        lowerCase: 'imsi (datasource)',
        titleCase: 'IMSI (datasource)',
      },
    },
    [InstallationTechnology.Other]: {
      image: otherImage,
      imageWidth: 80,
      name: intl.formatMessage(messages.other),
      serialName: {
        lowerCase: intl.formatMessage(messages.dataSource).toLowerCase(),
        titleCase: intl.formatMessage(messages.dataSource),
      },
    },
  };

  return configs[installationTechnology];
};
